












import EChart from 'vue-echarts';
import { COLORS_PALETTE } from '@/constants/DashboardFormattingRulesConstants';

const globalOptions = {
  color: COLORS_PALETTE,
};

export default {
  name: 'Chart',
  components: {
    EChart,
  },
  props: {
    autoresize: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  computed: {
    allOptions() {
      return {
        ...globalOptions,
        ...this.options,
      };
    },
  },
};
